import React, { useEffect, useState } from 'react'
import LiabilityForm, {
  LiabilityInputDataType,
  LiabilityOutputDataType,
} from '../components/forms/LiabilityForm'
import { useClaimant } from '../context/col'
import useAsync from '../hooks/useAsync'
import useGetData from '../hooks/useGetData'
import {
  CaseReportParamsType,
  CaseReportRespType,
  transformCaseReportRespToCaseReportParams,
} from '../models'
import { putCaseReport } from '../services/case-report/put'

export type LiabilityPageProps = {
  transitions: LiabilityPageTransitions
}

export type LiabilityPageTransitions = {
  goBack: () => void
  goToNextPage: () => void
}

const Liability = (props: LiabilityPageProps) => {
  const { state, dispatch } = useClaimant()
  const [ifEqual, setIfEqual] = useState<boolean>(true)

  useEffect(() => {
    dispatch({ type: 'control_change', payload: { controlChange: ifEqual } })
  }, [ifEqual])

  const { fetch: fetchData, pending: loading } = useGetData({})

  useEffect(() => {
    fetchData()
  }, [])

  const handleLiabilityPageBack = () => {
    // history.push(pathToClaimant)
    props.transitions.goBack()
  }

  const handleLiabilityPageSubmitted = (value: LiabilityOutputDataType) => {
    if (state.loadedCaseReportResp == null) {
      throw new Error('Illegal state -- no loadedCaseReportResp')
    }
    const origCaseReportResp: CaseReportRespType = state.loadedCaseReportResp
    const newCaseReportDataResp: CaseReportRespType = {
      ...origCaseReportResp,
      casePL: value.casePL,
      caseCommon: value.caseCommon,
    }

    const caseReportParamsForUpdate: CaseReportParamsType =
      transformCaseReportRespToCaseReportParams(newCaseReportDataResp)

    dispatch({
      type: 'update_caseReportParams',
      payload: { data: newCaseReportDataResp, page: 4 },
    })

    doPutCaseReport({
      caseReportId: state.caseReportId,
      caseReportParams: caseReportParamsForUpdate,
    })
  }

  function handleLiabilityPageDataChanged(isChanged: boolean): void {
    setIfEqual(isChanged)
  }

  const { fetch: doPutCaseReport, pending } = useAsync({
    promiseFn: (params: any) => putCaseReport(params),
    onData: () => {
      dispatch({ type: 'control_change', payload: { controlChange: true } })
      //history.push(pathToBankAccount)
      props.transitions.goToNextPage()
    },
    onError: (error) => {
      dispatch({ type: 'error', payload: { error: error.message } })
    },
  })

  const liabilityFormData: LiabilityInputDataType = {
    casePL: state.loadedCaseReportResp?.casePL ?? null,
    caseCommon: state.loadedCaseReportResp?.caseCommon ?? null,
  }

  return (
    <LiabilityForm
      caseReportId={state.caseReportId!}
      data={liabilityFormData}
      isPageConfirmInProgress={pending}
      errorMessage={state.error}
      onPageContinue={handleLiabilityPageSubmitted}
      onPageBack={handleLiabilityPageBack}
      notifyDataChanged={handleLiabilityPageDataChanged}
    />
  )
}

export default Liability
